import React, {Component} from "react";
import { Chart, registerables } from 'chart.js'
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { Helmet } from 'react-helmet';
import SchoolfeeList from "./schoolfees/SchoolfeeList";
import axios from "axios";
import Listprint from "../Listprint";
import SchoolfeeLine from "./schoolfees/SchoolfeeLine";
import { clearAppStoragePreservingTheme } from "../../theme/branding";
import { isAuthenticationRejection } from "../../offline/sessionPolicy";

Chart.register(...registerables)

const normalizeCurrency = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value.trim().toUpperCase();
    return String(value.code || value.currency || value.name || '').trim().toUpperCase();
}

const formatAmount = (value) => new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: 2
}).format(Number(value || 0));

class Dashboard extends Component{

    state = {
        schoolfees : [],
        expenses : [],
        wages : [],
        months: [],
        years : [],
        establishments : [],
        datasets: [
          {
            label: 'Rainfall',
            fill: false,
            lineTension: 0.5,
            backgroundColor: 'rgba(75,192,192,1)',
            borderColor: '#045fc0',
            borderWidth: 2,
            data: [47, 35, 66, 52, 33, 44, 20, 66, 12, 22, 44, 59]
          }
        ]
      }

      componentDidMount(){
        this.refreshToken()
        this.getStudents()
        this.expenses()
        this.getMonths()
        this.getYears()
        this.getEstablishments()
      }

      async getMonths(){
        var months = await axios.get("months");
        if(months.status === 200)
        {
            this.setState({
                months : months.data
            })
        }
    }

      async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token?.data?.data);
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("yearId", token?.data?.data?.scolary_year)
          }
        }catch(error) {
          if (!isAuthenticationRejection(error)) {
            console.info("Session conservée : validation du token indisponible hors connexion.");
            return;
          }

            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            clearAppStoragePreservingTheme();
            window.location.replace(process.env.REACT_APP_EVIVESOMA_COMPTA + `/login`)
        }
    }

      async getStudents(){
        const schoolfees = await axios.get('schoolfees')
        if(schoolfees.status === 200){
            this.setState({
                schoolfees : schoolfees.data
            })
        }
      }

      async expenses(){
          const expenses = await axios.get('expenses/operation/all')

          if(expenses.status === 200)
          {
              var expenseData = [] , wage = [];
              expenses.data.forEach((expense) => {
                  
                    var somme = 0, currency ="";
                    expense.expensedetails.forEach((expensedetail) =>{
                        somme = somme + expensedetail.amount
                        currency = normalizeCurrency(expensedetail.chartaccount.currency)

                        if(expense.type_expense === "Expense")
                        {

                            expenseData.push({
                                staff : expensedetail.staff && (expensedetail.staff.user.last_name +" "+ expensedetail.staff.user.first_name),
                                accounting : expensedetail.chartaccount.wording,
                                amount : Number(expensedetail.amount || 0),
                                currency : normalizeCurrency(currency),
                                mount : expensedetail.amount + " " + currency,
                                reason : expensedetail.reason,
                                month : expense.month.month,
                                year : expense.year.year, 
                            })
                        }
                        else if(expense.type_expense === "Wage"){
                            wage.push({
                                accounting : expensedetail.chartaccount.wording,
                                user : expense.staff && ((expense.staff.user.last_name || "") +" "+ (expense.staff.user.first_name || "")),
                                staff : expensedetail.staff && ((expensedetail.staff.user.last_name || "") +" "+ (expensedetail.staff.user.first_name || "")),
                                amount : Number(expensedetail.amount || 0),
                                currency : normalizeCurrency(currency),
                                mount : expensedetail.amount + " " + currency,
                                month : expense.month.month,
                                year : expense.year.year,
                            })
                            
                        }
                    })
                })
 
              
              this.setState({
                  wages : wage,
                  expenses : expenseData
              })

              
          }
      }

    async getYears(){
        var years = await axios.get('years');
        if(years.status === 200)
        {
            this.setState({years : years.data}) 
        }
    }

    async getEstablishments(){
        var establishments = await axios.get('establishments');
        if(establishments.status === 200)
        {
            this.setState({establishments : establishments.data}) 
        }
    }

    async handle_ (e){
      let request = await axios.get("year/" + e.target.value)
      if(request.status === 200){
        axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
        clearAppStoragePreservingTheme();
        window.location.replace(process.env.REACT_APP_EVIVESOMA_RH)
      }
    }

    async handl (e){
      if(e.target.value === "") return;
      let request = await axios.put("staffsestablishment/", {establishmentId : e.target.value})
      if(request.status === 200){
        axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
        clearAppStoragePreservingTheme();
        window.location.replace(process.env.REACT_APP_EVIVESOMA_RH)
      }
    }

    handleCheck = (permission) => {
        const permissions = localStorage.getItem("permissions")
            ? JSON.parse(localStorage.getItem("permissions"))
            : [];
        return permissions.some(item => permission === item.permission);
    }

    render(){
        const data = this.state.schoolfees
            .filter(schoolfee => schoolfee.month)
            .map(schoolfee => ({
                amount: Number(schoolfee.pay_mount || 0),
                month: schoolfee.month.id,
                currency: normalizeCurrency(
                    schoolfee.sectionschoolfeecategory?.currency
                    || schoolfee.schoolfeecategory?.currency
                )
            }))
            .filter(item => item.currency);

        const currencyCodes = Array.from(new Set([
            ...data.map(item => item.currency),
            ...this.state.expenses.map(item => item.currency),
            ...this.state.wages.map(item => item.currency)
        ].filter(Boolean)));

        const financialPositions = currencyCodes.map(currency => {
            const income = data
                .filter(item => item.currency === currency)
                .reduce((total, item) => total + item.amount, 0);
            const expenses = this.state.expenses
                .filter(item => item.currency === currency)
                .reduce((total, item) => total + item.amount, 0);
            const wages = this.state.wages
                .filter(item => item.currency === currency)
                .reduce((total, item) => total + item.amount, 0);

            return {
                currency,
                income,
                expenses,
                wages,
                outcome: expenses + wages,
                balance: income - expenses - wages
            };
        });

        const quickActions = [
            this.handleCheck("Afficher paiement") && { to: "/formschoolfee", icon: "plus-circle", label: "Nouvel encaissement", detail: "Enregistrer un paiement" },
            this.handleCheck("Afficher depense") && { to: "/expenses", icon: "arrow-up-right", label: "Nouvelle dépense", detail: "Saisir une sortie" },
            this.handleCheck("Afficher livre caisse") && { to: "/accountingbalances", icon: "book-open", label: "Livre de caisse", detail: "Consulter les mouvements" },
            this.handleCheck("Afficher rapport") && { to: "/reports", icon: "bar-chart-2", label: "Rapports", detail: "Analyser la période" }
        ].filter(Boolean);

        const activeYear = this.state.years.find(
            year => String(year.id) === String(localStorage.getItem("yearId"))
        );
        return(
            <div className="ev-dashboard ev-dashboard--finance">
                <Helmet>
                    <title>{ process.env.REACT_APP_NAME } | tableau de bord comptable</title>
                </Helmet>

                <div className="finance-hero">
                    <div className="ev-dashboard__heading">
                        <span className="ev-dashboard__eyebrow">Pilotage comptable</span>
                        <h1 className="ev-dashboard__title">La trésorerie, <em>en un regard</em></h1>
                        <p className="ev-dashboard__subtitle">Encaissements, sorties et solde disponible réunis dans une lecture claire de l’exercice.</p>
                    </div>
                    <div className="ev-dashboard__actions">
                        {
                            this.handleCheck("Afficher etablissement") &&(
                                <select aria-label="Niveau Scolaire" value={ localStorage.getItem("establishmentId")} onChange={this.handl}>
                                    <option>----</option>
                                    {
                                    this.state.establishments?.map((val) =>(
                                        <option value={val.id} key={val.id}>{ val.countryCode }</option>
                                    ))
                                    }
                                </select>
                            )
                        }

                        <select value={localStorage.getItem("yearId") || ""} onChange={this.handle_} aria-label="Exercice comptable">
                            {
                              this.state.years?.map((val) =>(
                                <option value={val.id} key={val.id}>{val.year}</option>
                              ))
                            }
                        </select>
                        <span className="finance-period-badge">
                            <FeatherIcon icon="calendar" size="17" />
                            Exercice {activeYear?.year || "en cours"}
                        </span>
                    </div>
                </div>

                {quickActions.length > 0 && (
                    <nav className="finance-quick-actions" aria-label="Actions comptables rapides">
                        {quickActions.map(action => (
                            <Link to={action.to} key={action.to}>
                                <span className="finance-quick-actions__icon"><FeatherIcon icon={action.icon} size="19" /></span>
                                <span><strong>{action.label}</strong><small>{action.detail}</small></span>
                                <FeatherIcon icon="chevron-right" size="17" />
                            </Link>
                        ))}
                    </nav>
                )}

                <section className="finance-cash">
                    <div className="finance-cash__heading">
                        <div>
                            <span className="ev-dashboard__eyebrow">Situation de trésorerie</span>
                            <h2>Synthèse des flux par devise</h2>
                            <p>Le solde présenté correspond aux encaissements moins les dépenses et salaires enregistrés.</p>
                        </div>
                        <FeatherIcon icon="pie-chart" size="22" />
                    </div>
                    <div className="finance-cash__currencies">
                        {financialPositions.length > 0 ? financialPositions.map(item => (
                            <article key={item.currency} className={item.balance < 0 ? "is-negative" : ""}>
                                <div className="finance-cash__currency-head">
                                    <span>{item.currency}</span>
                                    <small>Solde estimé</small>
                                </div>
                                <strong>{formatAmount(item.balance)} <small>{item.currency}</small></strong>
                                <dl>
                                    <div><dt>Encaissements</dt><dd>+ {formatAmount(item.income)}</dd></div>
                                    <div><dt>Décaissements</dt><dd>- {formatAmount(item.outcome)}</dd></div>
                                </dl>
                            </article>
                        )) : (
                            <p className="finance-cash__empty">Aucun mouvement comptable disponible pour cet exercice.</p>
                        )}
                    </div>
                </section>

                <div className="finance-kpis">
                    <article><span>Encaissements</span><strong>{this.state.schoolfees.length}</strong><small>paiements enregistrés</small></article>
                    <article><span>Dépenses</span><strong>{this.state.expenses.length}</strong><small>lignes de sortie</small></article>
                    <article><span>Opérations de paie</span><strong>{this.state.wages.length}</strong><small>lignes enregistrées</small></article>
                    <article><span>Devises actives</span><strong>{currencyCodes.length}</strong><small>caisses suivies</small></article>
                </div>

                <div className="finance-charts">
          {currencyCodes.length > 0 &&
            currencyCodes.map((currentCurrency) => {
                
              var labelss = [],
                some = 0,
                datas = [];
                this.state.months.forEach((month) =>{
                        some = 0;
                        
                        data.filter((mon) => mon.month === month.id && mon.currency === currentCurrency).forEach((val) => {
                                some = some + val.amount;
                            });
                            
                        datas.push(some);
                        labelss.push(month.month);
                })
              return (
                <div className="card finance-chart-card mb-3" key={currentCurrency}>
                    <div className="card-body">
                    <div className="finance-section-heading">
                        <div><span>Évolution mensuelle</span><h2>Encaissements en {currentCurrency}</h2></div>
                        <FeatherIcon icon="trending-up" size="21" />
                    </div>
                    <SchoolfeeLine
                        labels={labelss}
                        data={datas}
                        title={"Encaissements mensuels en " + currentCurrency}
                    />
                    </div>
                </div>
                );
            })}
        </div>


            <div className="finance-section-heading mt-4">
                <div><span>Journal récent</span><h2>Dernières opérations comptables</h2></div>
                <FeatherIcon icon="clock" size="21" />
            </div>

            <div className="row mt-3 finance-activity">

                <div className="col-md-12">
                    <SchoolfeeList orderBy={"all"} title="Dernières opérations sur paiements" />
                </div>



                <div className="col-md-6">
                    <div className="card shadow mb-4  overflow-hidden rounded rounded-3">
                        <div className="card-body">
                        <div className="h6 border-bottom pb-2 font-monospace">Dernières opérations salaires</div>
                        {
                            this.state.wages.length > 0 && (
                                <Listprint columns={[
                                    {
                                        label: 'Personnel',
                                        field: 'user',
                                        sort: 'asc',
                                        width: 200
                                    },
                                    {
                                        label: 'Montant',
                                        field: 'mount',
                                        sort: 'asc',
                                        width: 150
                                    },
                                    {
                                        label: 'Caisse',
                                        field: 'accounting',
                                        sort: 'asc',
                                        width: 150
                                    },
                                    {
                                        label: 'Mois',
                                        field: 'month',
                                        sort: 'asc',
                                        width: 150
                                    },
                                    {
                                        label: 'Année',
                                        field: 'year',
                                        sort: 'asc',
                                        width: 120
                                    },
                                    {
                                        label: 'Opérateur',
                                        field: 'staff',
                                        sort: 'asc',
                                        width: 150
                                    },
                                ]} rows={this.state.wages} title={"Dernières opérations salaires"}/>
                            )
                        }
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card shadow mb-4  overflow-hidden rounded rounded-3">
                        <div className="card-body">
                        <div className="h6 border-bottom pb-2 font-monospace">Dernières opérations de dépenses</div>
                        {
                            this.state.expenses.length > 0 && (
                                <Listprint columns={[
                                    {
                                        label: 'Montant',
                                        field: 'mount',
                                        sort: 'asc',
                                        width: 150
                                    },{
                                        label: 'Motif',
                                        field: 'reason',
                                        sort: 'asc',
                                        width: 150
                                    },
                                    {
                                        label: 'Compte',
                                        field: 'accounting',
                                        sort: 'asc',
                                        width: 200
                                    },
                                    {
                                        label: 'Mois',
                                        field: 'month',
                                        sort: 'asc',
                                        width: 150
                                    },
                                    {
                                        label: 'Année',
                                        field: 'year',
                                        sort: 'asc',
                                        width: 120
                                    },
                                    {
                                        label: 'Opérateur',
                                        field: 'staff',
                                        sort: 'asc',
                                        width: 150
                                    },
                                ]} rows={this.state.expenses} title={"Dernières opérations de dépenses"}/>
                            )
                        }
                        </div>
                    </div>
                    
                </div>

            </div>

            </div>
        )
    }
}
export default Dashboard;
